import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_PURCHASEDETAIL,
  DELETE_PURCHASEDETAIL,
  UPDATE_PURCHASEDETAIL,
  ADD_NEW_PURCHASEDETAIL,
} from "./actionType";

import {
  getPurchaseDetailSuccess,
  getPurchaseDetailFail,
  deletePurchaseDetailSuccess,
  deletePurchaseDetailFail,
  updatePurchaseDetailSuccess,
  updatePurchaseDetailFail,
  addPurchaseDetailSuccess,
  addPurchaseDetailFail,
} from "./action";

//Include Both Helper File with needed carriers
import {
  approvePurchaseDetailApi,
  getPurchaseDetailApi,
  updatePurchaseDetailApi,
  deletePurchaseDetailApi,
  addNewPurchaseDetailApi
} from "../../helpers/backend_helper";

function* getPurchaseDetail({ payload: purchaseDetail }) {
  try {
    const response = yield call(getPurchaseDetailApi, purchaseDetail);
    yield put(getPurchaseDetailSuccess(GET_PURCHASEDETAIL, response.data));
  } catch (error) {
    yield put(getPurchaseDetailFail(GET_PURCHASEDETAIL, error));
  }
}

function* onUpdatePurchaseDetail({ payload: purchaseDetail }) {
  try {
    if (purchaseDetail.setApprove) {
      const response = yield call(approvePurchaseDetailApi, purchaseDetail);
      yield put(updatePurchaseDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updatePurchaseDetailApi, purchaseDetail);
      yield put(updatePurchaseDetailSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
  } catch (error) {
    yield put(updatePurchaseDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeletePurchaseDetail({ payload: purchaseDetail }) {
  try {
    const response = yield call(deletePurchaseDetailApi, purchaseDetail);
    yield put(deletePurchaseDetailSuccess({ purchaseDetail, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deletePurchaseDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewPurchaseDetail({ payload: purchaseDetail }) {
  try {
    const response = yield call(addNewPurchaseDetailApi, purchaseDetail);
    yield put(addPurchaseDetailSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addPurchaseDetailFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetPurchaseDetail() {
  yield takeEvery(GET_PURCHASEDETAIL, getPurchaseDetail);
}

export function* watchUpdatePurchaseDetail() {
  yield takeEvery(UPDATE_PURCHASEDETAIL, onUpdatePurchaseDetail);
}

export function* watchDeletePurchaseDetail() {
  yield takeEvery(DELETE_PURCHASEDETAIL, onDeletePurchaseDetail);
}

export function* watchAddNewPurchaseDetail() {
  yield takeEvery(ADD_NEW_PURCHASEDETAIL, onAddNewPurchaseDetail);
}

function* purchaseDetailSaga() {
  yield all([
    fork(watchGetPurchaseDetail),
    fork(watchDeletePurchaseDetail),
    fork(watchUpdatePurchaseDetail),
    fork(watchAddNewPurchaseDetail)
  ]);
}

export default purchaseDetailSaga;
